import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { OptionSelect } from 'src/shared/components';
import { AccrualSummaryFilterEnums } from 'src/shared/enums';
import { TranslationFunction, useTranslate } from 'src/shared/providers';
import { mapEnumValueToArray } from 'src/shared/utils';

interface Props {
  filterValue: AccrualSummaryFilterEnums | undefined;
  onSelect: (value: AccrualSummaryFilterEnums) => void;
}

export const AccrualSummaryFiltersDropdown: FC<Props> = ({
  filterValue = AccrualSummaryFilterEnums.CURRENT,
  onSelect,
}) => {
  const { t } = useTranslate();

  const filterList = mapEnumValueToArray(AccrualSummaryFilterEnums).map((value) =>
    mapFilterOption(+value as AccrualSummaryFilterEnums, t),
  );

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Typography variant="body2" color="text.secondary">
        {t('accrualSummary.accrualFilter')}
      </Typography>

      <OptionSelect
        selectedOption={mapFilterOption(filterValue, t)}
        options={filterList}
        optionValue={({ value }) => value}
        optionLabel={({ label }) => label}
        onOptionSelect={({ value }) => onSelect(value)}
        sx={{ height: '40px' }}
      />
    </Stack>
  );
};

const mapFilterOption = (option: AccrualSummaryFilterEnums, t: TranslationFunction) => {
  switch (option) {
    case AccrualSummaryFilterEnums.PAST:
      return { value: option, label: t('global.past') };
    case AccrualSummaryFilterEnums.ALL:
      return { value: option, label: t('global.all') };
    case AccrualSummaryFilterEnums.CURRENT:
    default:
      return { value: option, label: t('global.current') };
  }
};
